<template>
  <div class="container">
    <div class="index-tel ">
      <div class="tel-solgan">{{ solgan }}</div>
      <div class="tel-solgan-2" v-if="solgan_2">{{ solgan_2 }}</div>

      <div class="tel-solgan-2" v-else>
        已为全国<span>{{ num }}</span
        >家企业提供创业服务
      </div>
      <div class="tel-input">
        <div class="tel-icon"></div>
        <input type="text" v-model="leads.tel" placeholder="请输入手机号" />
      </div>
      <div class="tel-button" @click="btn_save">立即咨询</div>
    </div>
  </div>
</template>

<script>
import { getleads } from "../view/api/api"; //引入api里面定义的方法
export default {
  props: ["solgan", "solgan_2", "service", "num"],
  data() {
    return {
      leads: {}
    };
  },
  methods: {
    async btn_save() {
      var _self = this;
      var data = _self.leads;
      var phone_reg = /^1[3456789]\d{9}$/;
      if (data.tel == "") {
        this.$toast("请输入手机号码");

        return false;
      } else {
        if (!phone_reg.test(data.tel)) {
          this.$toast("手机号码格式错误");

          return false;
        }
      }

      var parm = {
        tel: data.tel,
        service: this.service
      };

      const res = await getleads(parm);
      if (res.status == 1) {
        this.$toast({
          message: "提交成功",
          type: "success"
        });
        _self.leads.tel = "";
        _self.num += 1;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.index-tel {
  margin: 0 auto 0rem auto;
  height: 3.48rem;
  background: url(../../static/index/tel-box/tel-box-2.png) no-repeat;
  background-size: cover;
  flex-direction: column;
  overflow: hidden;

  .tel-solgan {
    margin-top: 0.4rem;
    font-size: 0.26rem;
    line-height: 0.37rem;
    height: 0.37rem;
    color: #1395ff;
    text-align: center;
    justify-content: center;
    @media (max-width: 991px) {
      font-size: 0.32rem;
      line-height: 0.42rem;
    }
  }

  .tel-solgan-2 {
    line-height: 0.33rem;
    height: 0.33rem;
    font-size: 0.18rem;
    color: #1b1c33;
    text-align: center;
    justify-content: center;
    margin-bottom: 0.24rem;
    @media (max-width: 991px) {
      font-size: 0.28rem;
      line-height: 0.33rem;
    }
    span {
      font-size: 0.24rem;
      color: #ff545a;
      @media (max-width: 991px) {
        font-size: 0.32rem;
      }
    }
  }

  .tel-input {
    margin: 0 auto 0.34rem auto;
    width: 5.91rem;
    height: 0.6rem;
    background: #ffffff;
    border-radius: 0.3rem;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0 0.63rem;
    display: flex;

    input {
      width: 100%;
      height: 100%;
      font-size: 0.18rem;
      border: none;
      @media (max-width: 991px) {
        font-size: 0.26rem;
      }
    }

    .tel-icon {
      width: 0.25rem;
      height: 0.4rem;
      background: url(../../static/index/tel-box/tel-icon-2.png) no-repeat;
      background-size: 100%;
      margin-right: 0.3rem;
    }
  }

  .tel-button {
    margin: 0 auto;
    width: 5.91rem;
    height: 0.72rem;
    background: #1395ff;
    border-radius: 0.36rem;
    text-align: center;
    line-height: 0.72rem;
    font-size: 0.26rem;
    color: #ffffff;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    @media (max-width: 991px) {
      font-size: 0.32rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/indextel.vue